export const crocodiles = (resolution, bias, percentR, rsi, kValue) => resolution === '1W'
    ? (bias + percentR + rsi + kValue) / 3
    : resolution === '1D'
        ? (3 * bias + percentR + rsi + kValue) / 3
        : resolution === '5' || resolution === '1' || resolution === '15'
            ? (30 * bias + percentR + rsi + kValue) / 3
            : NaN;
